/** Resolves API origin for fetch calls. Dev uses same-origin + Vite proxy. */
export function getApiOrigin(): string {
  const fromEnv = import.meta.env.VITE_API_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv.replace(/\/$/, '');
  }
  return '';
}
